import { render } from "./Product.vue?vue&type=template&id=a9543d2c&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=a9543d2c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9543d2c"],['__file',"resources/js/modules/product-categorization-drag-drop/components/filter/Product.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a9543d2c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a9543d2c', __exports__)) {
    api.reload('a9543d2c', __exports__)
  }
  
  module.hot.accept("./Product.vue?vue&type=template&id=a9543d2c&scoped=true", () => {
    api.rerender('a9543d2c', render)
  })

}


export default __exports__